<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Modification Sous Theme</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="propheteInfo.name"
                    label="Titre"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <vue-upload-multiple-image
                    v-if="propheteInfo.name"
                    style="margin-left: 160px"
                    v-model="images"
                    :data-images="images"
                    name="images"
                    accept="image/*	"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                  >
                  </vue-upload-multiple-image>
                  <v-progress-linear
                    v-if="showlowding && uploadPercentage < 100"
                    style="max-width: 190px; margin-left: 160px"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>
                <v-col cols="auto" style="margin-top: 16px">
                  <span>Premium:</span>
                </v-col>
                <v-col cols="auto">
                  <v-switch
                    v-model="propheteInfo.isLocked"
                    hide-details
                    inset
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-select
                    v-model="propheteInfo.listThemeId[0]"
                    :items="themeArray"
                    clearable
                    label="Theme"
                    item-text="title"
                    item-value="id"
                    outlined
                  ></v-select
                ></v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="propheteInfo.name.length <= 0"
                      class="info"
                      @click="UpdateProphete()"
                    >
                      Suivant
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import Constant from "@/utils/constants";
import { getAllTheme } from "@/views/qorani/services/services";
import store from "../../../store/image";

export default {
  components: { VueUploadMultipleImage },
  data() {
    return {
      fakePercentage: null,
      uploadPercentage: null,
      showlowding: false,
      theme: [],
      soustheme: [],
      themeArray: [],
      images: [],
      propheteInfo: {
        id: "",
        name: "",
        imgDBUrlId: "",
        listThemeId: [],
      },
      prophete: {
        name: "",
        imgDBUrlId: "",
      },
      propheteTheme: {
        listThemesId: [],
        propheteId: "",
      },
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
    };
  },
  // async beforeRouteEnter(to, from, next) {
  //   const PropheteId = to.params.id;
  //   try {
  //     const response = await axios.get(`${Constant.QORANI}prophete/get/${PropheteId}`);
  //     next((vm) => {
  //       vm.propheteInfo = response.data;
  //       vm.images.push({
  //         name: "",
  //         path: response.data.imageUrl,
  //         highlight: 1,
  //         default: 1,
  //       });
  //     });
  //   } catch (error) {
  //     console.error("Error fetching product details:", error);
  //     next(null);
  //   }
  // },
  async beforeRouteEnter(to, from, next) {
    const PropheteId = to.params.id;
    try {
      const response = await axios.get(
        `${Constant.QORANI}prophete/get/${PropheteId}`
      );
      next((vm) => {
        vm.propheteInfo = response.data;

        // Check if imgDBId exists and use getImageUrl, or fall back to imageUrl
        const imagePath = response.data.imgDBId
          ? vm.getImageUrl(response.data.imgDBId)
          : response.data.imageUrl;

        vm.images.push({
          name: "",
          path: imagePath, // Set the path using getImageUrl or fallback to imageUrl
          highlight: 1,
          default: 1,
        });
      });
    } catch (error) {
      console.error("Error fetching product details:", error);
      next(null);
    }
  },

  methods: {
    async filterFirebaseUrls() {
      for (const theme of this.soustheme) {
        const firebaseUrls = theme.listFileUrl.filter((url) =>
          url.includes("firebase")
        );
        if (firebaseUrls.length > 0) {
          console.log(`theme ID: ${theme.id}, Firebase URLs:`, firebaseUrls);
          await this.uploadFirebaseUrls(theme.id, firebaseUrls);
        }
      }
    },

    async uploadFirebaseUrls(PropheteId, firebaseUrls) {
      const formDataToSend = new FormData();

      try {
        // Fetch the image as a blob
        const response = await fetch(firebaseUrls);
        const blob = await response.blob();

        formDataToSend.append("file", blob, "image.jpg");
      } catch (error) {
        console.error(
          `Error converting image URL to File for Theme ID ${PropheteId}:`,
          error
        );
        return; // Exit function in case of an error
      }

      console.log(formDataToSend);

      try {
        // Upload the image
        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });

        if (!response.ok) {
          const errorResponse = await response.json();
          console.error(
            `Failed to upload URLs for Theme ID:`,
            response.statusText,
            errorResponse
          );
        } else {
          const result = await response.json();
          console.log(`Successfully uploaded URLs for Theme ID:`, result);

          if (result.id) {
            this.prophete.imgDBUrlId = result.id;
            this.propheteTheme.propheteId = this.propheteInfo.id;
            this.prophete.name = this.propheteInfo.name;
            this.prophete.isLocked = this.propheteInfo.isLocked;
            // console.log("imgDBUrlId:", this.prophete.imgDBUrlId);

            try {
              const responseProphete = await fetch(
                Constant.QORANI + "prophete/edit/" + this.propheteInfo.id,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(this.prophete),
                }
              );

              if (!responseProphete.ok) {
                const errorResponse = await responseProphete.json();
                console.error(
                  "Failed to update theme:",
                  responseProphete.statusText,
                  errorResponse
                );
              } else {
                const resultCategorie = await responseProphete.json();
                console.log("Successfully updated theme:", resultCategorie);
              }
            } catch (error) {
              console.error(
                `Error while updating theme for ID ${this.propheteInfo.id}:`,
                error
              );
            }
          }
        }
      } catch (error) {
        console.error(`Error while uploading URLs for Theme ID:`, error);
      }
    },
    async loadImage(item) {
      if (item.fileUrlDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          item.svgContent = svgContent; // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        item.imgUrl = `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`;
      }
    },

    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    async UpdateProphete() {
      const imageId = store.state.imageId;
      console.log("id", imageId);
      this.propheteTheme.listThemesId[0] = this.propheteInfo.listThemeId[0];
      if (this.propheteTheme.listThemesId[0] === null) {
        this.propheteTheme.listThemesId = [];
      }
      console.log(this.propheteTheme.listThemesId);
      this.propheteTheme.propheteId = this.propheteInfo.id;
      this.prophete.name = this.propheteInfo.name;

      this.prophete.isLocked = this.propheteInfo.isLocked;
      const responseProphete = await fetch(
        Constant.QORANI + "prophete/edit/" + this.propheteInfo.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.prophete),
        }
      );

      if (responseProphete.ok) {
        const editListThemes = `${Constant.QORANI}prophete/editListThemes`;

        const responseTheme = await fetch(editListThemes, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.propheteTheme),
        });

        if (!responseTheme.ok) {
          alert(
            "Une erreur est survenue lors de l'association du thème, veuillez réessayer plus tard, Merci."
          );
          return;
        }

        try {
          window.location.reload();
        } catch (error) {
          alert(
            "Une erreur est survenue lors de l'ajout du theme, veuillez réessayez plus tard, Merci."
          );
        }
      }
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.prophete.imgDBUrlId = imageId;
        console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },

    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.propheteInfo.imageUrl = "";
        this.propheteInfo.imageId = "";

        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    convertImagePathToFile(element) {
      const byteString = atob(element.path.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/jpeg" });

      return new File([blob], element.name);
    },
  },
  async created() {
    this.themeArray = await getAllTheme();
  },
};
</script>
